import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type Props = {
  isFormDisabled: boolean;
  displayOnCareDirectory: boolean;
  displayOnBookingDirectory: boolean;
  handleCheckBoxStateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  forcePrivateListing: boolean;
  showCareDirectoryToggle?: boolean;
  showBookingDirectoryToggle?: boolean;
};

export default function CareBusinessSettingsForm({
  isFormDisabled,
  displayOnCareDirectory,
  displayOnBookingDirectory,
  handleCheckBoxStateChange,
  forcePrivateListing,
  showCareDirectoryToggle = true,
  showBookingDirectoryToggle = false,
}: Props): JSX.Element {
  const visibleToggles = [
    showCareDirectoryToggle ? "care" : null,
    showBookingDirectoryToggle ? "booking" : null,
  ].filter(Boolean);

  if (visibleToggles.length === 0) return <></>;

  return (
    <Stack spacing={4} sx={{ mt: 4 }}>
      <Accordion defaultExpanded sx={{ borderRadius: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1 }}>
            <Typography variant="h6">Visibility</Typography>
            </Box>
          </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            {showCareDirectoryToggle ? (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isFormDisabled}
                    name="displayOnCareDirectory"
                    checked={!!displayOnCareDirectory}
                    onChange={handleCheckBoxStateChange}
                  />
                }
                label={
                  forcePrivateListing
                    ? "Show on Plany365 Care directory (pending care approval)"
                    : "Show on Plany365 Care directory"
                }
              />
            ) : null}
            {showBookingDirectoryToggle ? (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={isFormDisabled}
                    name="displayOnBookingDirectory"
                    checked={!!displayOnBookingDirectory}
                    onChange={handleCheckBoxStateChange}
                  />
                }
                label="Show on Timely365 Booking directory"
              />
            ) : null}
            {forcePrivateListing ? (
              <Typography variant="caption" color="text.secondary">
                Unverified care businesses stay hidden until care approval is completed. Verified AFH licenses do not need this pending approval note.
              </Typography>
            ) : !displayOnCareDirectory && !displayOnBookingDirectory ? (
              <Typography variant="caption" color="text.secondary">
                Turn on each directory where you want this business to appear.
              </Typography>
            ) : visibleToggles.length > 1 ? (
              <Typography variant="caption" color="text.secondary">
                Care and Booking directory visibility can be managed separately.
              </Typography>
            ) : null}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
